var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04688 5.3125C7.04688 6.1413 7.37612 6.93616 7.96217 7.52221C8.54822 8.10826 9.34307 8.4375 10.1719 8.4375C11.0007 8.4375 11.7955 8.10826 12.3816 7.52221C12.9676 6.93616 13.2969 6.1413 13.2969 5.3125C13.2969 4.4837 12.9676 3.68884 12.3816 3.10279C11.7955 2.51674 11.0007 2.1875 10.1719 2.1875C9.34307 2.1875 8.54822 2.51674 7.96217 3.10279C7.37612 3.68884 7.04688 4.4837 7.04688 5.3125Z",
    stroke: "#fff",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4219 14.2969C16.4219 16.2385 16.4219 17.8125 10.1719 17.8125C3.92188 17.8125 3.92188 16.2385 3.92188 14.2969C3.92188 12.3552 6.72009 10.7812 10.1719 10.7812C13.6237 10.7812 16.4219 12.3552 16.4219 14.2969Z",
    stroke: "#fff",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.e3746dba6436de103e123d8a60fea477.svg";
export { ForwardRef as ReactComponent };